/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ExternalListItemTypeEnum = "containers" | "external_contacts" | "item" | "shipments" | "tickets" | "voyages" | "%future added value";
export type FilterInput = {
    key: string;
    values: Array<string>;
};
export type ExternalItemListHeaderQueryVariables = {
    type?: ExternalListItemTypeEnum | null;
    filters?: Array<FilterInput> | null;
    sortKey?: string | null;
    page?: number | null;
    perPage?: number | null;
    searchQuery?: string | null;
    voyageEtaStart?: string | null;
    voyageEtaEnd?: string | null;
    voyageEtdStart?: string | null;
    voyageEtdEnd?: string | null;
    dischargeDateStart?: string | null;
    dischargeDateEnd?: string | null;
    includeArchived?: boolean | null;
    showFilters?: boolean | null;
};
export type ExternalItemListHeaderQueryResponse = {
    readonly externalItemList: {
        readonly " $fragmentRefs": FragmentRefs<"ExternalItemListHeader_data">;
    };
};
export type ExternalItemListHeaderQuery = {
    readonly response: ExternalItemListHeaderQueryResponse;
    readonly variables: ExternalItemListHeaderQueryVariables;
};



/*
query ExternalItemListHeaderQuery(
  $type: ExternalListItemTypeEnum
  $filters: [FilterInput!]
  $sortKey: String
  $page: Int
  $perPage: Int
  $searchQuery: String
  $voyageEtaStart: Date
  $voyageEtaEnd: Date
  $voyageEtdStart: Date
  $voyageEtdEnd: Date
  $dischargeDateStart: Date
  $dischargeDateEnd: Date
  $includeArchived: Boolean
  $showFilters: Boolean
) {
  externalItemList(type: $type, filters: $filters, sortKey: $sortKey, page: $page, perPage: $perPage, searchQuery: $searchQuery, voyageEtaStart: $voyageEtaStart, voyageEtaEnd: $voyageEtaEnd, voyageEtdStart: $voyageEtdStart, voyageEtdEnd: $voyageEtdEnd, dischargeDateStart: $dischargeDateStart, dischargeDateEnd: $dischargeDateEnd, includeArchived: $includeArchived, showFilters: $showFilters) {
    ...ExternalItemListHeader_data
  }
}

fragment ExternalItemListHeader_data on ExternalItemList {
  sortKeys {
    key
    title
  }
  filters {
    key
    name
    values {
      label
      displayLabel
      selected
      count
    }
  }
  totalCount
  downloadToken
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dischargeDateEnd"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dischargeDateStart"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeArchived"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perPage"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showFilters"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortKey"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "voyageEtaEnd"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "voyageEtaStart"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "voyageEtdEnd"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "voyageEtdStart"
},
v14 = [
  {
    "kind": "Variable",
    "name": "dischargeDateEnd",
    "variableName": "dischargeDateEnd"
  },
  {
    "kind": "Variable",
    "name": "dischargeDateStart",
    "variableName": "dischargeDateStart"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "includeArchived",
    "variableName": "includeArchived"
  },
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  },
  {
    "kind": "Variable",
    "name": "perPage",
    "variableName": "perPage"
  },
  {
    "kind": "Variable",
    "name": "searchQuery",
    "variableName": "searchQuery"
  },
  {
    "kind": "Variable",
    "name": "showFilters",
    "variableName": "showFilters"
  },
  {
    "kind": "Variable",
    "name": "sortKey",
    "variableName": "sortKey"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type"
  },
  {
    "kind": "Variable",
    "name": "voyageEtaEnd",
    "variableName": "voyageEtaEnd"
  },
  {
    "kind": "Variable",
    "name": "voyageEtaStart",
    "variableName": "voyageEtaStart"
  },
  {
    "kind": "Variable",
    "name": "voyageEtdEnd",
    "variableName": "voyageEtdEnd"
  },
  {
    "kind": "Variable",
    "name": "voyageEtdStart",
    "variableName": "voyageEtdStart"
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ExternalItemListHeaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v14/*: any*/),
        "concreteType": "ExternalItemList",
        "kind": "LinkedField",
        "name": "externalItemList",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ExternalItemListHeader_data"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v9/*: any*/),
      (v2/*: any*/),
      (v8/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v11/*: any*/),
      (v10/*: any*/),
      (v13/*: any*/),
      (v12/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "ExternalItemListHeaderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v14/*: any*/),
        "concreteType": "ExternalItemList",
        "kind": "LinkedField",
        "name": "externalItemList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SortKey",
            "kind": "LinkedField",
            "name": "sortKeys",
            "plural": true,
            "selections": [
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Filter",
            "kind": "LinkedField",
            "name": "filters",
            "plural": true,
            "selections": [
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FilterValue",
                "kind": "LinkedField",
                "name": "values",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayLabel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "selected",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "downloadToken",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6e95755c9cdc5aefdf2ab38fc935ca3c",
    "id": null,
    "metadata": {},
    "name": "ExternalItemListHeaderQuery",
    "operationKind": "query",
    "text": "query ExternalItemListHeaderQuery(\n  $type: ExternalListItemTypeEnum\n  $filters: [FilterInput!]\n  $sortKey: String\n  $page: Int\n  $perPage: Int\n  $searchQuery: String\n  $voyageEtaStart: Date\n  $voyageEtaEnd: Date\n  $voyageEtdStart: Date\n  $voyageEtdEnd: Date\n  $dischargeDateStart: Date\n  $dischargeDateEnd: Date\n  $includeArchived: Boolean\n  $showFilters: Boolean\n) {\n  externalItemList(type: $type, filters: $filters, sortKey: $sortKey, page: $page, perPage: $perPage, searchQuery: $searchQuery, voyageEtaStart: $voyageEtaStart, voyageEtaEnd: $voyageEtaEnd, voyageEtdStart: $voyageEtdStart, voyageEtdEnd: $voyageEtdEnd, dischargeDateStart: $dischargeDateStart, dischargeDateEnd: $dischargeDateEnd, includeArchived: $includeArchived, showFilters: $showFilters) {\n    ...ExternalItemListHeader_data\n  }\n}\n\nfragment ExternalItemListHeader_data on ExternalItemList {\n  sortKeys {\n    key\n    title\n  }\n  filters {\n    key\n    name\n    values {\n      label\n      displayLabel\n      selected\n      count\n    }\n  }\n  totalCount\n  downloadToken\n}\n"
  }
};
})();
(node as any).hash = '550bd8bafbc3abd9e032262caeb8cbad';
export default node;
